import { WebStorageStateStore } from 'oidc-client-ts';

const getClientId = () => {
  const origin = typeof window.getOrigin === 'function' ? window.getOrigin() : 'GRID';
  switch (origin) {
    case 'GRID':
      return '5E04CBD4-1664-4FDA-B00A-4EBA1425456A';
    case 'CENTRIKID':
      return 'F557D26C-0B9A-11EA-8D71-362B9E155667';
    case 'FUGE':
      return '0B98ECDD-7EF1-4FBA-ABB3-0077E7706511';
    case 'STUDENTLIFE':
      return '1F7ED1F6-3F74-4035-991C-902467BEB1F0';
    default:
      return 'B4963680-11AD-47C9-AAB7-8D7F12252363';
  }
};

export const getUserManagerSettings = () => ({
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  authority: window.getAccountUrl(),
  client_id: getClientId(),
  redirect_uri: `${window.location.origin}/#/oauth2/callback`,
  response_type: 'code',
  scope: 'openid email profile',
  post_logout_redirect_uri: `${window.location.origin}/#/login`,
  silent_redirect_uri: `${window.location.origin}/silent.html`,
  silentRequestTimeoutInSeconds: 30000,
  accessTokenExpiringNotificationTimeInSeconds: 60,
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  loadUserInfo: true,
  monitorAnonymousSession: true,
  stopCheckSessionOnError: false,
  stateStore: new WebStorageStateStore({ store: window.localStorage }),
});
